import { Provider } from '@angular/core';
import { ORGANIZATION_SERVICE } from '../../../../features/organization-list/application/tokens/token';
import { map } from 'rxjs';
import { toOrganization } from '../mappers/organization.mapper';
import { OrganizationAdminApi } from '@tradgine/data-access/tradgine-data';

export function provideOrganizationListProviders(): Provider[] {
    return [
        {
            provide: ORGANIZATION_SERVICE,
            useFactory: (api: OrganizationAdminApi) => {
                return {
                    getOrganizations: () => {
                        return api
                            .getAll()
                            .pipe(
                                map((result) =>
                                    result
                                        .map((orgs => orgs.map(toOrganization)))
                                        .mapErr((err) => new Error('Failed to fetch organizations'))
                                )
                            );
                    },
                };
            },
            deps: [OrganizationAdminApi],
        },
    ];
}
